import Layout from '@/layout'

const userRouter = {
  path: "/user",
  redirect:'/user/list',
  name:'userIndex',
  hiddeChilden:true,
  meta: { 
    title: 'menu.userManage', 
    iconClass: 'el-icon-user', 
    module:'user', 
    keepAlive: true,
    roles:['USER_ADMIN','USER_OBSERVER']
  },
  component: Layout,
  children:[
    {
      path: "/user/list",
      name: "userList",
      hidden:false,
      component: () => import( "@/views/user"),
      meta: { 
        title: 'menu.userManage', 
        iconClass: 'el-icon-user', 
        module:'user', 
        keepAlive: true,
        roles:['USER_ADMIN','USER_OBSERVER']
      }
    },
  ]
}

export default userRouter